export default __webpack_public_path__ + "static/media/actual_tennis.eb5d0753.png";